module.exports = __webpack_public_path__ + "img/pdf.02b67f46.png";